export default "__VITE_ASSET__C$SAlIdd__"